import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell, Center, Container, Stack, Text, Title } from '@mantine/core';

function LegalShell() {
  return (
    <AppShell padding="md">
      <AppShell.Main>
        <Center mih="100vh">
          <Container size="md" w="100%">
            <Stack gap="lg" mt="xl">
              <Title order={1} ta="center">
                LeadSync
              </Title>
              <Outlet />
              <Text ta="center" c="dimmed" size="xs">
                Last updated: {new Date().toISOString().slice(0, 10)}
              </Text>
            </Stack>
          </Container>
        </Center>
      </AppShell.Main>
    </AppShell>
  );
}

export const Route = createFileRoute('/legal')({ component: LegalShell });
